<template>
    <div id="article" class="article">
      <div class="article-header">
        <h1 class="article-title">{{ oitarticle.fields.title }}</h1>
        <span class="article-meta">
          <span v-if="oitarticle.fields.date">{{ oitarticle.fields.date | dateFormat }}</span>
          <template v-if="(oitarticle.fields.author && oitarticle.fields.date)"> | </template>
          <span v-if="oitarticle.fields.author">by: <span class="author">{{ oitarticle.fields.author }}</span></span>
        </span>
      </div>
      <div>
        <div class="article-content">
          <vue-markdown :source="oitarticle.fields.content">
          </vue-markdown>
        </div>
      </div>
    </div>
</template>
<script>
 import Prism from 'prismjs'
 import 'prismjs/themes/prism.css'

 export default {
   name: 'oitarticle',
   data() {
     return {
       entry_id: this.$route.params.entry_id,
       oitarticle: {
         sys: {},
         fields: {}
       }
     }
   },
   methods: {
     getArticle() {
       console.log("Requesting " + this.entry_id)
       this.$contentful
              .getEntry(this.entry_id)
              .then((res) => {
                console.log("fetched article")
                console.log(res)
                this.oitarticle = res
              })
              .catch((error) => {
                console.log("Error fetching article")
              })
     }
   },
   created() {
     this.getArticle()
   },
   updated(){
     Prism.highlightAll();
   },
   metaInfo: {
     title: 'Article'
   }
 }
</script>
<style>
 .article-header {
     padding-bottom: 2em;
     margin-top: 20px;
     text-align: left;
 }

 .article-content {
     text-align: left;
     min-height: 400px;
     line-height: normal;
     font-size: 18px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     line-height: 1.5;
     letter-spacing: normal;
     color: #002330;
 }

 .author {
     color: #00a1c8;
 }

 .article-meta {
     font-size: 18px;
     font-weight: 600;
     font-style: normal;
     font-stretch: normal;
     line-height: normal;
     letter-spacing: normal;
     color: #a39c9b;
 }

 .article-title {
     color: #002330;
     border-bottom: 2px solid #00a1c8;
     padding-bottom: .1em;
 }

 .article {
     margin-left: 8%;
     margin-right: 8%;
 }

 .article-content {
     font-family: 'Open Sans', sans-serif;
     font-size: 18px;
     font-weight: normal;
     font-style: normal;
     font-stretch: normal;
     letter-spacing: normal;
     color: #002330;
     line-height: normal;
 }

 .article-content p {
     margin-bottom: 1em;
 }

 .article-content h1 {
     text-align: left;
     font-weight: 600;
     font-size: 24px;
     margin-top: 0.6em;
     margin-bottom: 0;
     color: #e4522a;
     border-bottom: 1px solid #a39c9b;
 }

 .article-content h2{
     text-align: left;
     font-weight: 600;
     font-size: 24px;
     color: #002330;
     margin-bottom: 0px;
     margin-top: 0.6em;
 }

 .article-content h3 {
     text-align: left;
     font-weight: 600;
     font-size: 18px;
     color: #002330;
     margin-bottom: 0px;
     margin-top: 0.6em;
 }

 .article-content h4 {
     text-align: left;
     font-weight: 600;
     font-size: 24px;
     color: #e4522a;
     margin-top: 0.6em;
     margin-bottom: 0;
 }

 .article-content img {
     border: 1px solid  #a39c9b;
     padding: 5px;
     margin-top: 0.6em;
     margin-bottom: 0;
     display: block;
 }

 .article-content blockquote {
     background: #f9f9f9;
     border-left: 10px solid #ccc;
     margin: 1.5em 10px;
     padding: 0.5em 10px;
 }

 .article-content blockquote p {
     display: inline;
 }

 .article-content ul {
     list-style: none; /* Remove default bullets */
     margin-bottom: 0;
     margin-left: 1em;
 }

 .article-content ul li::before {
     content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
     color: #e4522a; /* Change the color */
     font-weight: bold; /* If you want it to be bold */
     display: inline-block; /* Needed to add space between the bullet and the text */
     width: 1em; /* Also needed for space (tweak if needed) */
     margin-left: -1em; /* Also needed for space (tweak if needed) */
 }

 .article-content ul li ul {
     /* remove bullets from nested lists */
     list-style-type: none;
     color: #002330;
     margin-left: 1.5em;
     margin-top: 0.4em;
 }

 .article-content ul li ul li::before {
     display: inline;
     content: none;
 }

</style>
